<template lang="pug">
  #ChallengeForfeitActionMenu
    ChallengeForfeitTeamActionMenu(v-if="challenge.between === 'groups'" :challenge="challenge")
    template(v-else)
      slot(name="trigger")
      BModal(
        :active.sync="isModalActive"
        :can-cancel="['escape', 'outside']"
        has-modal-card
      )
        .modal-card
          LeaveChallenge(@confirm="handleLeaveChallenge" @cancel="closeModal")
</template>

<script>
import { mapActions } from "vuex";
import WtActionMenu from "@@/WtActionMenu/WtActionMenu";
import WtActionMenuItem from "@@/WtActionMenuItem/WtActionMenuItem";
import ChallengeForfeitTeamActionMenu from "@@/Challenge/ChallengeForfeitTeamActionMenu";
import LeaveChallenge from "@@/Challenges/LeaveChallenge.vue";

export default {
  name: "ChallengeForfeitActionMenu",

  components: {
    LeaveChallenge,
    WtActionMenu,
    WtActionMenuItem,
    ChallengeForfeitTeamActionMenu
  },

  props: {
    challenge: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      errorForfeitingChallenge: false,
      isModalActive: false
    };
  },

  methods: {
    ...mapActions("challenges", ["removeMembersFromChallenge"]),
    ...mapActions(["snackBar"]),
    ...mapActions("pages", ["setPageLoaded"]),

    openModal() {
      this.isModalActive = true;
    },

    closeModal() {
      this.isModalActive = false;
    },

    async handleLeaveChallenge() {
      if (this.challenge.id) {
        try {
          await this.removeMembersFromChallenge({
            challengeId: this.challenge.id,
            memberIds: [this.$auth.user().id]
          });

          // refresh auth.user().challenges
          await this.$auth.fetch();

          // After leaving the challenge trigger a refetch for:
          // Challenges page and challenge detail page. NOTE: the Challenges page will not do a
          // full refetch if MyDashboard is "loaded". So, we also set MyDashboard to false.
          this.setPageLoaded({ key: "Challenges", value: false });
          this.setPageLoaded({
            key: `Challenge${this.challenge.id}`,
            value: false
          });
          this.setPageLoaded({
            key: `MyDashboard`,
            value: false
          });

          // using $router.push here to
          // go back to the Challenges page, which
          // triggers the created method (currently where the challenge data is loaded)
          this.$router.push({ name: "Challenges" });

          const challengeName = this.challenge.name;

          this.snackBar({
            duration: 5000,
            type: "is-success",
            message: "You are no longer a member of " + challengeName
          });

          this.closeModal();
        } catch (error) {
          this.errorForfeitingChallenge = true;
          console.error("Error leaving challenge:", error);
        }
      }
    }
  }
};
</script>

<style lang="sass" scoped>
#ChallengeForfeitActionMenu
  // override b-table, etc.
  /deep/ .level:not(.top)
    padding: 0 !important
</style>
